































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ParcelDetail } from '@/models/ParcelDetail';
import { CivicAddress } from '@/models/CivicAddress';
import HRMDataInfo from '@/components/HRMDataInfo.vue';
import TaxesPanel from '@/components/TaxesPanel.vue';
import DemographicsPanel from '@/components/DemographicsPanel.vue';
import SalesHistoryPanel from '@/components/SalesHistoryPanel.vue';
import ListingUtil from '../utils/ListingUtil';

@Component({
    components: {
        HRMDataInfo,
        TaxesPanel,
        DemographicsPanel,
        SalesHistoryPanel,
    },
})
export default class ParcelDetailsDialog extends Vue {

    public widthThresholdValue: number = 768;
    public heightThresholdValue: number = 415;

    public showDialog: boolean = false;
    public tab: string = 'overview';

    public civicAddressColumns = [
        { name: 'CivicNum', align: 'left', label: 'Civic Number', field: 'CivicNum', style: 'width: 40px;' },
        { name: 'StreetName', align: 'left', label: 'Street Name', field: 'StreetName', style: 'width: 40px;' },
        { name: 'StreetType', align: 'left', label: 'Street Type', field: 'StreetType', style: 'width: 40px' },
        { name: 'City', align: 'left', label: 'Community', field: 'City', style: 'width: 40px' },
        { name: 'Municipality', align: 'left', label: 'Municipality', field: 'Municipality', style: 'width: 40px' },
        { name: 'LotNum', align: 'left', label: 'Lot Number', field: 'LotNum', style: 'width: 40px' },
        { name: 'PID', align: 'left', label: 'PID', field: 'PID', style: 'width: 60px;'},
    ];

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'showParcelDialog') {
            this.onShowDialog();
        }
    });

    public onOpenShareDialog() {
        this.$store.dispatch('showShareDialog', 'PARCEL');
    }

    get config() {
        return this.$store.state.config;
    }

    get map() {
        return this.$store.state.map;
    }

    get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    get selectedParcelDetail(): ParcelDetail | null {
        return this.$store.state.parcels.selectedParcelDetail;
    }

    get civicAddressData(): CivicAddress[] | null {
        if (this.$store.state.parcels.selectedParcelDetail && this.$store.state.parcels.selectedParcelDetail.ParcelData.CivicAddresses) {
            return this.$store.state.parcels.selectedParcelDetail.ParcelData.CivicAddresses;
        }
        return null;
    }

    get formattedParcelSize(): string {
        const parcelSize = Number(this.selectedParcelDetail?.ParcelData?.ParcelSizeFtSq);
        return ListingUtil.getParcelSizeAcres(parcelSize);
    }

    public onShowDialog() {
        this.showDialog = true;
        this.tab = 'overview';
    }
}

